import './Footer.scss'
function Footer() {
    return (
      <div className="footer-container">
        <span>&copy; <span style={{color:'#FAD403',fontWeight:'700'}}>Max</span> <span className="f-700" style={{fontWeight:'700'}}>Drive</span> <span>2022&nbsp;&nbsp;&nbsp;Privacy Policy</span></span>
      </div>
    );
  }
  export default Footer;